jQuery(document).ready(function ($) {
    var path = window.location.pathname;
    var explodedPath = path.split('/');
    $('a').each(function () {
        var link = $(this).attr('href');

        if (link) {
            // add `blog`-ref to internal links
            // link.includes(process.env.WEBSITE_URL) &&
            // !link.includes(process.env.APP_URL) &&
            if (
                link.includes('https://placing-me.com') &&
                !link.includes('https://blog.placing-me.com') &&
                !link.includes('?ref=')
            ) {
                link = link + '?ref=blog';
            }

            /* add the slug of the blog post as the `registerRoute`-Parameter (if visitor is on a blog post) */
            // link.includes(process.env.WEBSITE_URL) &&
            // !link.includes(process.env.APP_URL) &&
            if (
                /* only alter links to the main site */
                link.includes('https://placing-me.com') &&
                !link.includes('https://blog.placing-me.com') &&
                !link.includes('?registerRoute=') &&
                /* check if the user is looking at a blog post */
                explodedPath.length > 2 &&
                explodedPath[1] === 'post'
            ) {
                link = link + (link.includes('?ref') ? '&' : '?') + 'registerRoute=' + explodedPath[2];
            }

            $(this).attr('href', link);

            // add target="_blank" to extern links
            if (!link.includes(window.location.hostname) && link.includes('http')) {
                $(this).attr('target', '_blank');
            }
        }
    });

    var title;
    $('.post a')
        .each(function () {
            title = $(this).title ? $(this).title : $(this).html();
        })
        .attr('title', title);
});
